import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './component/Login/Login';
import Search from './component/Search/Search';
import Upload from './component/Upload/Upload';
import Table from './component/TableAPI/CofProjectTable';
import VersionPage from './component/TableAPI/VersionCOF';
import CofProjectDati from './component/TableAPI/CofProjectDati';
import FileUpload from './component/Upload/FileUpload';
import { ChakraProvider } from '@chakra-ui/react';

function App() {
    return (
        <ChakraProvider>
            <div className="App">
                <Router>
                    <Routes>
                        <Route path='/' element={<Login />} />
                        <Route path='/search' element={<Search />} />
                        <Route path="/project/version/:version" element={<VersionPage />} />
                        <Route path='/upload' element={<Upload />} />
                        <Route path="/file-upload" element={<FileUpload />} />
                    </Routes>
                </Router>
            </div>
        </ChakraProvider>
    );
}

export default App;